// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MRDG","colBig":"styles_colBig__2tG-A","colSmall":"styles_colSmall__37Q0J"};